import type { ConceptDef } from '../types';

export const rhymingPairs: ConceptDef = {
  kind: 'tileMatch',
  id: 'rhyming-pairs',
  label: 'Rhyming Pairs',
  category: 'Literacy',
  description: 'Hear a word; tap one that rhymes.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Rhymes with cat?', answer: '🎩 hat' },
      { say: 'Rhymes with star?', answer: '🚗 car' },
      { say: 'Rhymes with tree?', answer: '🐝 bee' },
      { say: 'Rhymes with fun?', answer: '🌞 sun' },
      { say: 'Rhymes with cake?', answer: '🏞 lake' },
    ],
  },
};
